"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Result = exports.okSymbol = void 0;
exports.okSymbol = Symbol('success');
function ok(value) {
    var _a;
    return _a = {},
        _a[exports.okSymbol] = true,
        _a.value = value,
        // Helpers
        _a.isOk = function () {
            return true;
        },
        _a.isErr = function () {
            return false;
        },
        _a;
}
// Drops the `Error` header and the frames of this file, so the stack starts at the caller of `Result.err`
var captureStack = function () {
    var _a;
    return (_a = new Error().stack) === null || _a === void 0 ? void 0 : _a.split('\n').filter(function (line) { return line !== 'Error' && !/do-not-throw\.(ts|js)\b/.test(line); }).join('\n');
};
function err(error, opts) {
    var _a;
    return _a = {},
        _a[exports.okSymbol] = false,
        _a.error = error,
        _a.cause = opts === null || opts === void 0 ? void 0 : opts.cause,
        _a.stack = captureStack(),
        // Helpers
        _a.isOk = function () {
            return false;
        },
        _a.isErr = function () {
            return true;
        },
        _a;
}
function fromPromise(promise, mapError) {
    return __awaiter(this, void 0, void 0, function () {
        var data, e_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, promise];
                case 1:
                    data = _a.sent();
                    return [2 /*return*/, exports.Result.ok(data)];
                case 2:
                    e_1 = _a.sent();
                    return [2 /*return*/, exports.Result.err(mapError(e_1), { cause: e_1 })];
                case 3: return [2 /*return*/];
            }
        });
    });
}
function from(fn, mapError) {
    try {
        var data = fn();
        return exports.Result.ok(data);
    }
    catch (e) {
        return exports.Result.err(mapError(e), { cause: e });
    }
}
/**
 * Passes a failure up unchanged, cause and stack included — where `Result.err(x.error)` would
 * build a new Err and lose both. Takes an `Err` only, so the caller has checked `isErr()` first.
 */
function propagate(err) {
    return err;
}
exports.Result = {
    ok: ok,
    err: err,
    from: from,
    fromPromise: fromPromise,
    propagate: propagate,
};
//# sourceMappingURL=do-not-throw.js.map